import { render, staticRenderFns } from "./query-result.vue?vue&type=template&id=78454dec&scoped=true&"
import script from "./query-result.vue?vue&type=script&lang=js&"
export * from "./query-result.vue?vue&type=script&lang=js&"
import style0 from "./query-result.vue?vue&type=style&index=0&id=78454dec&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78454dec",
  null
  
)

export default component.exports